function OrderOwner($el)
{
    this.$el = $el;
    this.$owner = this.$el.find('[data-owner]');
    this.$ownerInput = this.$el.find('[data-owner-input]').hide();
    this.$settings = this.$el.find('[data-settings]');
    this.$save = this.$el.find('[data-save]').hide();
    this.$modal = this.$el.find('.modal');
    this.$spinner = $('<i></i>', {
        'class' : 'fa fa-spinner fa-spin',
        'style' : 'margin-right:10px;'
    });

    this.base = 'd-ib lh-0 va-m fw-600 bdrs-10em pX-15 pY-15 ';

    this.events();
}

OrderOwner.prototype.events = function()
{
    var self = this;

    this.$settings.on('click', function(){
        self.$settings.hide();
        self.$owner.hide();
        self.$ownerInput.show();
        self.$save.show();
    });

    this.$save.on('click', function(){
        if(self.$ownerInput.val().toString() !== self.$ownerInput.data('default-value').toString()) {
            self.$modal.find('.modal-body').html('<p>Are you sure you want to change the owner of this order to <strong>'+self.$ownerInput.find('option:selected').text()+'</strong>?</p>');
            self.$modal.modal('show');
        } else {
            self.hideEdit();
        }
    });

    this.$modal.find('.btn-primary').on('click', function(){
        $(this).prepend(self.$spinner);
        self.save();
    });

    this.$modal.find('.btn-secondary').on('click', function(){
        self.hideEdit();
        self.$modal.modal('hide');
        self.$ownerInput.val(self.$statusInput.data('default-value'));
    });
}

OrderOwner.prototype.hideEdit = function()
{
    this.$settings.show();
    this.$owner.show();
    this.$ownerInput.hide();
    this.$save.hide();
}

OrderOwner.prototype.save = function() {
    var self = this,
        value = this.$ownerInput.val();

    $.ajax({
        method: 'POST',
        url: '/orders/' + this.$el.data('order-number') + '/owner',
        data: {user_id: value}
    }).done(function (msg) {
        self.hideEdit();
        self.$modal.modal('hide');
        self.$modal.find('.btn-primary i').remove();
        var className = ($.trim(value) === "") ? 'bgc-blue-50 c-blue-500' : 'bgc-green-50 c-green-500';
        if (msg.success) {
            self.$ownerInput.data('default-value', value);
            self.$owner
                .find('span')
                .attr('class', self.base + className)
                .text(self.$ownerInput.find('option:selected').text());
        } else {
            alert('Er is helaas iets fout gegaan, probeer later opnieuw of neem contact op met Fluffy Media.');
        }
    });
}

function ResendEmail($el)
{
    this.$el = $el;
    this.$modal = this.$el.next('.modal');

    this.events();
}

ResendEmail.prototype.events = function()
{
    var self = this;

    this.$el.on('click', function(e){
        e.preventDefault();
        self.$modal.modal('show');
    });

    this.$modal.find('.btn-primary').on('click', function(){
        window.location = self.$el.attr('href');
    });

    this.$modal.find('.btn-secondary').on('click', function(){
        self.$modal.modal('hide');
    });
}

$(document).ready(function(){
    var $container = $('[data-owner-container]');
    if($container.length == 1)
        new OrderOwner($container);

    var $resendEmail = $('[data-resend-email]');
        new ResendEmail($resendEmail);
});
